import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';
import AIWebRetrievalUrlField from './AIWebRetrievalUrlField';

interface AIWebRetrievalCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    urlValue: string;
    onUrlChange: (value: string) => void;
    disabled?: boolean;
    localizer?: IStringLocalizer;
    registerPopoversCb?: (popoverIds: string[]) => void;
}

/**
 * Checkbox component for opting into public web retrieval during AI processing.
 */
export const AIWebRetrievalCheckbox: React.FC<AIWebRetrievalCheckboxProps> = ({
    checked,
    onChange,
    urlValue,
    onUrlChange,
    disabled = false,
    localizer,
    registerPopoversCb
}) => {
    const localize = useLocalizer(localizer);

    React.useEffect(() => {
        if (registerPopoversCb) {
            setTimeout(() => {
                registerPopoversCb(['ai-web-retrieval-popover']);
            }, 100);
        }
    }, [registerPopoversCb]);

    return (
        <div className="form-check" style={{ marginBottom: '15px' }}>
            <input
                type="checkbox"
                className="form-check-input"
                id="enableWebRetrieval"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            />
            <label
                className="form-check-label"
                htmlFor="enableWebRetrieval"
                style={{ marginLeft: '7px', fontWeight: 'normal' }}
            >
                {localize("Enable web retrieval")}
            </label>
            <a
                id="ai-web-retrieval-popover"
                data-container="body"
                role="button"
                className="m-l-5"
                data-toggle="popover"
                data-html="true"
                data-placement="top"
                data-content={localize("We will search public web sources to supplement your documents.")}
            >
                <img height="14" src="/images/help-icon-dark-gray.png" />
            </a>
            <AIWebRetrievalUrlField
                value={urlValue}
                onChange={onUrlChange}
                disabled={disabled || !checked}
                localizer={localizer}
            />
        </div>
    );
};

export default AIWebRetrievalCheckbox;
